export const SENTRY_ENDPOINT = process.env.SENTRY_ENDPOINT;
export const NODE_ENV = process.env.NODE_ENV || 'development';
export const AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID;
export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
export const isProd = NODE_ENV === 'production';
export const CONTEXT = process.env.CONTEXT;
export const DEFAULT_PAGE_SIZE = process.env.DEFAULT_PAGE_SIZE || 20;

export const WINGS_API_ENDPOINT = process.env.WINGS_API_ENDPOINT || 'https://api.wings.dev';
